import { FC } from 'react';
import LawyerMenu from 'containers/AppContainer/SideBar/LawyerMenu';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import OpeningManagerMenu from 'containers/AppContainer/SideBar/OpeningManagerMenu';
import CourtManagerMenu from 'containers/AppContainer/SideBar/CourtManagerMenu';
import ExpertMenu from 'containers/AppContainer/SideBar/ExpertMenu';
import PreOpeningManagerMenu from 'containers/AppContainer/SideBar/PreOpenManagerMenu';
import ConsultationManagerMenu from 'containers/AppContainer/SideBar/ConsultationManagerMenu';
import TransactionManagerMenu from 'containers/AppContainer/SideBar/TransactionManagerMenu';
interface SideMenuProps {
  pushToAndReset: Function;
  isMenuOpen: boolean;
  isManager?: boolean;
  isExpert?: boolean;
}

const SideMenu: FC<SideMenuProps> = ({
  pushToAndReset,
  isMenuOpen,
  isManager,
  isExpert,
}) => {
  if (isManager && userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER))
    return (
      <OpeningManagerMenu
        pushToAndReset={pushToAndReset}
        isMenuOpen={isMenuOpen}
      />
    );
  else if (
    (isManager && userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)) ||
    (isManager &&
      userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER))
  )
    return (
      <CourtManagerMenu
        pushToAndReset={pushToAndReset}
        isMenuOpen={isMenuOpen}
      />
    );
  else if (
    isManager &&
    userPrivileges.userHasPrivilege(PRIVILEGES.ISPREOPENMANAGER)
  )
    return (
      <PreOpeningManagerMenu
        pushToAndReset={pushToAndReset}
        isMenuOpen={isMenuOpen}
      />
    );
  else if (
    isManager &&
    userPrivileges.userHasPrivilege(PRIVILEGES.ISCONSULTATIONMANAGER)
  )
    return (
      <ConsultationManagerMenu
        pushToAndReset={pushToAndReset}
        isMenuOpen={isMenuOpen}
      />
    );
  else if (
    isManager &&
    userPrivileges.userHasPrivilege(PRIVILEGES.ISTRANSACTIONMANAGER)
  )
    return (
      <TransactionManagerMenu
        pushToAndReset={pushToAndReset}
        isMenuOpen={isMenuOpen}
      />
    );
  else if (isExpert)
    return (
      <ExpertMenu pushToAndReset={pushToAndReset} isMenuOpen={isMenuOpen} />
    );
  return <LawyerMenu pushToAndReset={pushToAndReset} isMenuOpen={isMenuOpen} />;
};

export default SideMenu;
